import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/common/Footer";

const Desktop22 = () => {
    const navigate = useNavigate();

    return (
        <div className="bg-[#f9f9f9] w-full overflow-x-hidden">
            {/* Hero Section */}
            <section className="relative bg-gradient-to-b from-[#06010A] to-[#260345] text-white flex flex-col md:flex-row items-center justify-between px-8 md:px-16 lg:px-24 py-20 overflow-hidden">
                {/* Decorative Ellipses */}
                <div className="absolute inset-0 overflow-hidden">
                    <div className="absolute w-[400px] h-[400px] bg-[#7B3FE4]/40 rounded-full blur-3xl top-[-100px] left-[-100px]" />
                    <div className="absolute w-[350px] h-[350px] bg-[#E6C1FF]/30 rounded-full blur-3xl bottom-[-150px] right-[-100px]" />
                </div>

                {/* Subtle Rectangle Background */}

                {/* Left Content */}
                <div className="relative z-10 max-w-xl">
                    <h3 className="text-lg text-[#ffffffbf] mb-3">AI Interview Prep</h3>
                    <h1 className="text-4xl md:text-5xl font-semibold leading-tight mb-6">
                        Prepare for interviews as easily as starting a conversation
                    </h1>
                    <p className="text-gray-200 mb-8 text-base md:text-lg">
                        Simply enter the position you’re applying for and use AI-generated
                        questions and sample answers to ease your next interview.
                    </p>

                    <button
                        onClick={() => navigate("/auth")}
                        className="bg-[#ffc403] text-black font-bold px-6 py-3 rounded-xl hover:bg-[#e6b800] transition"
                    >
                        Get Started
                    </button>
                </div>

                {/* Right Image */}
                <div className="relative z-10 mt-12 md:mt-0">
                    <img
                        src="https://c.animaapp.com/mge1sasxzrNszH/img/image-60.png"
                        alt="Resume Preview"
                        className="w-[350px] md:w-[450px] object-contain"
                    />
                </div>
            </section>

            {/* Section 1: Practice Efficiently */}
            <section className="bg-[#f9f9f9] py-20 px-6 md:px-16 lg:px-24 text-center text-[#22033c] relative">
                <h2 className="text-3xl md:text-4xl font-semibold mb-4">
                    Practice more efficiently and confidently
                </h2>

                {/* Features */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-12 max-w-6xl mx-auto">
                    {[
                        {
                            title: "Tailored Questions",
                            desc: "Get customized interview questions based on your role, skills, and experience.",
                        },
                        {
                            title: "Relevant Answers",
                            desc: "Receive AI-generated example answers crafted for your specific job position.",
                        },
                        {
                            title: "Diverse Scenarios",
                            desc: "Explore multiple interview rounds — technical, HR, and behavioral — to prepare comprehensively.",
                        },
                    ].map((item, i) => (
                        <div
                            key={i}
                            className="flex flex-col items-center text-center space-y-3"
                        >
                            <h3 className="font-semibold text-lg md:text-xl">
                                {item.title}
                            </h3>
                            <p className="text-base text-[#22033c]/80 max-w-sm">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>

                {/* Continuous Improvement */}
                <div className="mt-16 flex flex-col items-center text-center space-y-3 max-w-lg mx-auto">
                    <h3 className="font-semibold text-lg md:text-xl">
                        Continuous Improvement
                    </h3>
                    <p className="text-base text-[#22033c]/80">
                        Learn from curated feedback and updated questions reflecting current
                        hiring trends.
                    </p>
                </div>
            </section>

            {/* Section 2: Focus on Key Topics */}
            <section className="bg-[#f9f9f9] py-20 px-6 md:px-16 lg:px-24 text-center">
                <h2 className="text-3xl md:text-4xl font-semibold text-[#22033c] mb-4">
                    Focus on key topics for any position
                </h2>
                <p className="text-[#22033c]/80 text-lg mb-10 max-w-3xl mx-auto">
                    Master essential areas every interviewer evaluates — from technical
                    expertise to communication and problem-solving.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6 max-w-6xl mx-auto">
                    {[
                        {
                            title: "Core Concepts",
                            desc: "Learn the fundamentals of your domain from algorithms to design principles.",
                            example: 'Example: "Explain supervised vs. unsupervised learning"',
                        },
                        {
                            title: "Problem Solving",
                            desc: "Practice real-world questions that assess your analytical thinking.",
                            example:
                                'Example: "How would you debug a model performing poorly in production?"',
                        },
                        {
                            title: "Behavioral & Soft Skills",
                            desc: "Prepare answers for situational and HR questions using the STAR format.",
                            example:
                                'Example: "Describe a time you resolved a team conflict."',
                        },
                        {
                            title: "Latest Trends & Tools",
                            desc: "Stay updated on current technologies and frameworks relevant to your field.",
                            example:
                                'Example: "What are the ethical challenges in generative AI?"',
                        },
                        {
                            title: "Communication",
                            desc: "Tips for structuring clear, confident, and concise answers.",
                            example:
                                'Example: "How would you explain your project to a non-technical audience?"',
                        },
                    ].map((item, i) => (
                        <div
                            key={i}
                            className="bg-gradient-to-b from-[#1a012d] to-[#3b0a6e] text-white rounded-xl shadow-md p-6 flex flex-col text-left space-y-3"
                        >
                            <h3 className="font-semibold text-lg">{item.title}</h3>
                            <p className="text-gray-200 text-sm">{item.desc}</p>
                            <p className="text-[#e6c1ff] text-xs italic">{item.example}</p>
                        </div>
                    ))}
                </div>
            </section>


            {/* Footer (optional) */}
            {/* <Footer /> */}
        </div>
    );
};

export default Desktop22;
